<template>
  <v-expansion-panel 
    @click="handleExpand"
  >
    <v-expansion-panel-header>{{ $t('dtouch.workspace.parrillaDviewcontent.title', locale) }}</v-expansion-panel-header>
    <v-expansion-panel-content style="padding-top:16px;">
      <v-row>
        <v-col
          cols="12"
          sm="12"
        >
          <v-autocomplete
            v-model="ID"
            :items="workspaces"
            :loading="loading"
            outlined
            dense
            item-text="name"
            item-value="id"
            :label="$t('dtouch.workspace.parrillaDviewcontent.id', locale)"
            hide-details
            @change="handleChange"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          sm="12"
        >
        <v-checkbox
          v-model="showDFeel"
          :label="$t('dtouch.workspace.parrillaDviewcontent.showDFeel', locale)"
          @change="handleChange"
        />
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<script>
import api from '@/services/api'
export default {
  name: 'ParrillaDviewcontentForm',
  props: {
    workspaceID: {
      type: String,
      default: null,
    },
    locale: {
      type: String,
      default: null,
    },
    onChangeData: {
      type: Function,
      default: null,
    },
  },
  data: () => ({
    ID: null,
    workspaces: [],
    loading: true,
    showDFeel: false,
  }),
  methods: {
    getWorkspaces () {
      api.getAllWithoutLimit('dtouch', `v1/system/dviewcontent/`)
        .then(response => {
          this.workspaces = response.data.map(item => {
            return ({
              id: item.ID,
              name: item.Name
            })
          })
          this.loading = false
      })
    },
    getData () {
      api.getItem('dtouch', `v1/system/workspaces/`, `${this.workspaceID}/parrilla-dviewcontent`)
        .then(response => {
          this.ID = response ? response.ID : null
          this.showDFeel = response && response.ShowMoscaDFeel ? true : false
        })
    },
    handleExpand () {
      this.getWorkspaces()
      if(!this.ID && this.workspaceID) this.getData()
    },
    handleChange () {
      this.onChangeData({
        ID: this.ID,
        ShowMoscaDFeel: this.showDFeel,
      })
    }
  },
}
</script>

